<template>
	<div class="overviews">
		<div class="row" v-if="exclude">
			<div
				class="col-md-3">
				<!-- :number="overview.submission_count" -->
				<overview
					:number="overviewValue(exclude)"
					:prev-number="prevOverviewValue(exclude)"
					:stats-enabled="getStatsEnabled(exclude)"
					:type="overviewDisplay(exclude, 'type')"
					:icon="overviewDisplay(exclude, 'icon')"
					:icon-type="overviewDisplay(exclude, 'iconType')"
					:icon-color="getIconColor(exclude)"
					:text="overviewDisplay(exclude, 'text')"
					:info="overviewDisplay(exclude, 'info')"
					:clickable="clickable"
					:is-fetching="isFetchingstatistic"
					:class="{ 'active' : (clickable && overviewActive === exclude) }"
					@click="actionClick(exclude)"
					:is-can-redirected="isCanRedirected(exclude)"
					:redirect-link="overviewDisplay(exclude, 'redirectLink')"
				>
				</overview>
			</div>
		</div>
		<div class="row">
			<div
				:class="col"
				v-for="item in authorizedItems"
				:key="item">
				<!-- :number="overview.submission_count" -->
				<overview
					:number="overviewValue(item)"
					:prev-number="prevOverviewValue(item)"
					:stats-enabled="getStatsEnabled(item)"
					:type="overviewDisplay(item, 'type')"
					:icon="overviewDisplay(item, 'icon')"
					:icon-type="overviewDisplay(item, 'iconType')"
					:icon-color="getIconColor(item)"
					:text="overviewDisplay(item, 'text')"
					:info="overviewDisplay(item, 'info')"
					:clickable="clickable"
					:is-fetching="isFetchingstatistic"
					:class="{ 'active' : (clickable && overviewActive === item), 'clickable active' : selectOverview === item}"
					@click="actionClick(item)"
					:is-can-redirected="isCanRedirected(item)"
					:redirect-link="overviewDisplay(item, 'redirectLink')"
				>
				</overview>
			</div>
		</div>
	</div>
</template>

<script>
import Overview from '@/components/Overview.vue';
import { orderOverviewItems, supplierPendingOverviewItems, deliveryPendingOverviewsItems } from '@/lib/statics';

export default {
	props: {
		overview: Object,
		items: {
			type: Array,
			default: () => [],
		},
		layout: {
			type: String,
			default: 'small',
		},
		capabilities: {
			type: Array,
			default: () => [],
		},
		clickable: {
			type: Boolean,
			default: false,
		},
		source: {
			type: String,
			default: null,
		},
		isFetching: {
			type: Boolean,
			default: false,
		},
		excludeBoard: {
			type: String,
			default: null,
			// is used when we wanna make overview have style active without click these overview
		},
	},
	data() {
		return {
			overviewSelected: null,
		};
	},
	components: {
		overview: Overview,
	},
	methods: {
		overviewValue(item) {
			return this.overview[item];
		},
		prevOverviewValue(item) {
			return this.overview[`prev_${item}`] !== undefined ? this.overview[`prev_${item}`] : null;
		},
		overviewDisplay(item, type) {
			let display = this.overviewDisplayData[item][type];
			if (type === 'text' || type === 'info') {
				display = this.$t(display);
			}
			return display;
		},
		userCan(capability) {
			return this.capabilities.indexOf(capability) !== -1;
		},
		getIconColor(item) {
			const colors = {
				grey: '#333',
				blue: '#0098DA',
				green: '#3cb878',
				yellow: '#DEB317',
			};
			let color = colors.grey;
			if (item === 'submission_count') {
				color = colors.blue;
			} else if (item === 'transaction_count') {
				color = colors.green;
			} else if (item === 'unpaid_count') {
				color = colors.yellow;
			}
			return color;
		},
		actionClick(key) {
			this.overviewSelected = key;

			if (this.clickable === false) {
				if (this.selectedOverview !== '') {
					this.overviewSelected = this.selectedOverview;
				}
			}

			if (this.clickable) {
				this.$emit('action', key);
			}
		},
		getStatsEnabled(item) {
			return this.overviewDisplayData[item]?.stats_enabled;
		},
		assignAdditionalCapabilities(authorizedItems, source = 'orders') {
			let additionalCapabilities = [];
			if (source === 'leads-order') {
				additionalCapabilities = [
					'leads_order_total',
					'leads_order_failed',
				];
			} else {
				additionalCapabilities = [
					'shipping_process_return',
					'shipping_return_to_shipper',
					'shipping_return_completed',
					'shipping_return_broken',
					'shipping_cancelled',
					'shipping_refunded',
				];
			}
			if (this.userCan('statistic_shipping_completed')) {
				additionalCapabilities.forEach((item) => {
					const checkItem = authorizedItems.findIndex(authorizedItem => authorizedItem === item);
					if (checkItem === -1) {
						authorizedItems.push(item);
					}
				});
			}

			if (this.exclude) {
				authorizedItems = authorizedItems.filter(item => item !== this.exclude);
			}
			return authorizedItems;
		},
		isCanRedirected(item) {
			return this.overviewDisplayData[item]?.isCanRedirected;
		},
		assignAdditionalCapabilitiesOthers(authorizedItems, source) {
			let additionalCapabilities = [];
			if (source === 'pending') {
				additionalCapabilities = [
					'supplier_pending_h1',
					'supplier_pending_h2',
					'supplier_pending_h3',
					'supplier_pending_h4',
				];
			}
			if (source === '3pl-pending') {
				additionalCapabilities = [
					'third_party_logistic_pending_h1',
					'third_party_logistic_pending_h2',
					'third_party_logistic_pending_h3',
					'third_party_logistic_pending_h4',
				];
			}
			if (source === 'order_statistics') {
				additionalCapabilities = [
					'order_todays',
					'order_weeks',
					'order_months',
				];
			}
			additionalCapabilities.forEach((item) => {
				const checkItem = authorizedItems.findIndex(authorizedItem => authorizedItem === item);
				if (checkItem === -1) {
					authorizedItems.push(item);
				}
			});
			return authorizedItems;
		},
	},
	computed: {
		col() {
			const length = this.authorizedItems.length;
			let currCol = 'col-sm-6 col-md-3';
			if (this.layout === 'small') {
				currCol = 'col-sm-6';
			} else if (this.layout === 'medium') {
				currCol = 'col-sm-6 col-md-4';
			} else if (this.layout === 'auto') {
				currCol = 'col';
			}
			if (length === 1) {
				currCol = 'col-sm-12';
			} else if (length === 3 || length % 3 === 0) {
				currCol = 'col-md-4 col-sm-6';
			} else if (length % 4 >= 0) {
				currCol = 'col-md-3 col-sm-6';
			} else if (length % 4 >= 0) {
				currCol = 'col-md-3 col-sm-6';
			}

			if (length === 5) {
				currCol = 'col-sm-12 col-md';
			}
			if (length === 2 && this.layout === 'auto') {
				currCol = 'col-md-6';
			}
			return currCol;

			// return this.layout === 'small' ? 'col-sm-6' : 'col-sm-6 col-md-3';
		},
		authorizedItems() {
			const filter = item => this.userCan(`statistic_${item}`);
			let authorizedItems = this.items.filter(filter);

			if (this.source === 'orders') {
				authorizedItems = this.assignAdditionalCapabilities(authorizedItems);
			}
			if (this.source === '3pl-pending' || this.source === 'pending' || this.source === 'order_statistics') {
				authorizedItems = this.assignAdditionalCapabilitiesOthers(authorizedItems, this.source);
			}

			if (this.source === 'leads-order') {
				authorizedItems = this.assignAdditionalCapabilities(authorizedItems, this.source);
			}

			return authorizedItems;
		},
		overviewActive() {
			let selected = this.overviewSelected;
			if (selected === null) {
				selected = this.items.length > 0 ? this.items[0] : '';
			}
			return selected;
		},
		isFetchingstatistic() {
			return this.isFetching;
		},
		selectOverview() {
			return this.selectedOverview;
		},
		overviewItems() {
			let overview = [];
			if (this.source === 'orders' || this.source === 'order_statistics') {
				overview = orderOverviewItems;
			} else if (this.source === '3pl-pending') {
				overview = deliveryPendingOverviewsItems;
			} else if (this.source === 'pending') {
				overview = supplierPendingOverviewItems;
			} else {
				overview = orderOverviewItems;
			}

			return overview;
		},
		overviewDisplayData() {
			return this.overviewItems;
		},
		routeActive() {
			return this.$route?.params?.type ?? null;
		},
		exclude() {
			return this.excludeBoard;
		},
	},
	watch: {
		routeActive() {
			this.overviewSelected = null;
		},
	},
};
</script>
